<template>
  <div id="dashboard" style="min-height: 350px;">
    <!-- <div id="dashboard" class="content"> -->
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
          <h3 class="block-title">基本信息</h3>
      </div>-->
      <div>
        <form
          action="be_forms_elements.html"
          method="POST"
          enctype="multipart/form-data"
          onsubmit="return false;"
        >
          <div class="row justify-content-center">
            <div class="col-lg-6 col-xl-6" style="padding: 0 50px">
              <h2 class="content-heading pt-0">
                基本信息
                <!-- <div style="width:6em" class="text-center">
                  <i class="far fa-address-card fa-4x text-default"></i>
                  <div class="mt-3">
                    <label
                    v-if="isPile"
                  >{{message&&message.USER_WHITE_TYPE?(message.USER_WHITE_TYPE=="0" ?"普通":message.USER_WHITE_TYPE=="1" ?"白名单":""):""}}</label>
                  <label
                    v-if="isCarport"
                  >{{message&&message.CARPORT_WHITE_TYPE?(message.CARPORT_WHITE_TYPE=="0" ?"普通":message.CARPORT_WHITE_TYPE=="1" ?"白名单":""):""}}</label>
                </div>
                </div>-->
              </h2>
              <div class="form-group">
                <div class="form-group">
                  <div class="form-group inline-block" style="width:100%">
                    <label>用户类型</label>
                    <select
                      disabled
                      class="form-control"
                      id="cell-type"
                      name="cell-type"
                      :value="isPile&&message?message.USER_WHITE_TYPE :isCarport&&message?message.CARPORT_WHITE_TYPE :''"
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in userType"
                        :key="index"
                        :value="item.value"
                      >{{item.label}}</option>
                    </select>
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label>用户ID</label>
                    <input type="text" class="form-control" disabled v-model="form.userId" />
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label>手机号码</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.mobilePhone"
                      maxlength="11"
                      :disabled="isSee"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label>实体卡号</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.userCard"
                      maxlength="10"
                      :disabled="isSee"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label>账户余额(元)</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="message?changeTwoDecimal(message.BALANCE):''"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:100%" v-show="isPile">
                    <label style="color: #fff;">1</label>
                    <input type="text" class="form-control" style="border:none" />
                  </div>
                  <!-- <div class="form-group inline-block" style="width:48%;">
                      <label>修改余额(元)</label>
                      <input type="text" class="form-control" v-model="form.balanceMoney" />
                  </div>-->
                </div>
                <div class="form-group text-right">
                  <button
                    v-if="!isSee&&message&&((pileDelBtn&&isPile&&message.USER_WHITE_TYPE=='1')||(carportDelBtn&&isCarport&&message.CARPORT_WHITE_TYPE=='1'))"
                    style="min-width:23%;margin-right:2%"
                    class="btn btn-sm btn-primary"
                    @click="delWhiteUser()"
                  >移出白名单</button>
                  <button
                    v-if="!isSee&&message&&((pileJoinBtn&&isPile&&message.USER_WHITE_TYPE=='0')||(carportJoinBtn&&isCarport&&message.CARPORT_WHITE_TYPE=='0'))"
                    style="min-width:23%;margin-right:2%"
                    class="btn btn-sm btn-primary"
                    @click="showAdd()"
                  >加入白名单</button>
                  <button
                    style="min-width:23%;"
                    class="btn btn-sm btn-primary"
                    @click="submit()"
                    v-if=" editBtn&&!isSee"
                  >保存</button>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-6" style="padding: 0 50px">
              <h2 class="content-heading pt-0">白名单信息</h2>
              <div class="form-group">
                <div class="form-group">
                  <!-- 充电白名单显示 -->
                  <div v-if="isPile ">
                    <!-- <div class="form-group" style="width:100%;">
                      <label for="example-text-input">所在区域</label>
                      <div class="col-sm-12 p-0">
                        <select
                          class="form-control width-33"
                          @change="provinceSel()"
                          v-model="pro"
                          :disabled="hasGroupId"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in provinceList"
                            :key="index"
                            :value="item.DISTRICT_CODE"
                          >{{item.DISTRICT_NAME}}</option>
                        </select>
                        <select
                          class="form-control width-33"
                          @change="citySel()"
                          v-model="city"
                          :disabled="hasGroupId"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in cityList"
                            :key="index"
                            :value="item.DISTRICT_CODE"
                          >{{item.DISTRICT_NAME}}</option>
                        </select>
                        <select
                          class="form-control width-33"
                          @change="disSel()"
                          v-model="dis"
                          :disabled="hasGroupId"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in districtList"
                            :key="index"
                            :value="item.DISTRICT_CODE"
                          >{{item.DISTRICT_NAME}}</option>
                        </select>
                      </div>
                    </div>-->
                    <div class="form-group inline-block" style="width:100%;">
                      <label>小区名称</label>
                      <el-select
                        filterable
                        placeholder="请输入"
                        style="width: 100%;"
                        v-model="form.groupId"
                        :disabled="hasGroupId||isSee"
                        @change="changeGroupId()"
                      >
                        <el-option
                          v-for="item in cellList"
                          :key="item.CELL_ID"
                          :label="item.CELL_NAME"
                          :value="item.CELL_ID"
                        ></el-option>
                      </el-select>
                    </div>
                    <!-- <div class="form-group inline-block" style="width:100%;">
                        <label>时长包名</label>
                        <select
                          class="form-control inline-block col-sm-12"
                          v-model="form.packageId"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in packageList"
                            :key="index"
                            :value="item.PACKAGE_ID"
                          >{{item.DESCRIPTION}}</option>
                        </select>
                    </div>-->
                    <div class="form-group inline-block" style="width:48%;margin-right:4%">
                      <label>每日限制时长</label>
                      <select
                        class="form-control col-sm-12"
                        v-model="form.limitDuration"
                        :disabled="isSee"
                      >
                        <option selected="selected" disabled="disabled" value>请选择</option>
                        <option v-for="(item,index) in 24" :key="index" :value="item">{{item+'小时'}}</option>
                      </select>
                    </div>
                    <div class="form-group inline-block" style="width:48%;">
                      <label>每日重置时间</label>
                      <select class="form-control" v-model="  form.resetHour" :disabled="isSee">
                        <option selected="selected" disabled="disabled" value>请选择</option>
                        <option
                          v-for="(item,index) in 24"
                          :key="index"
                          :value="index>9?index+':00':('0'+index + ':00')"
                        >{{index>9?index+':00':('0'+index + ':00')}}</option>
                      </select>
                    </div>
                  </div>
                  <!-- 车棚白名单显示 -->
                  <div class="form-group inline-block" style="width:100%;" v-if="isCarport">
                    <label>车棚名称</label>
                    <el-select
                      v-model="form.carportId"
                      filterable
                      placeholder="请选择"
                      style="width: 100%;"
                      :disabled="isSee||(isCarport&&message&&message.CARPORT_WHITE_TYPE == '1')"
                    >
                      <el-option
                        v-for="item in carportList"
                        :key="item.CARPORT_ID"
                        :label="item.CARPORT_NAME"
                        :value="item.CARPORT_ID"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label>白名单生效日期</label>
                    <input
                      type="text"
                      class="js-flatpickr form-control"
                      :class="{'bg-white-ab':isSee,'bg-white':!isSee}"
                      name="example-flatpickr-default"
                      v-model="  form.startEffectiveTime"
                      placeholder="请选择"
                      :disabled="isSee"
                      :readonly="isSee"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label>白名单失效日期</label>
                    <input
                      type="text"
                      class="js-flatpickr form-control"
                      :class="{'bg-white-ab':isSee,'bg-white':!isSee}"
                      name="example-flatpickr-default"
                      v-model="  form.expiredTime"
                      placeholder="默认无限制"
                      :disabled="isSee"
                      :readonly="isSee"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:100%;">
                    <label>备注</label>
                    <input type="text" class="form-control" v-model="form.remark" :disabled="isSee" />
                  </div>
                </div>
                <div class="form-group text-right">
                  <button
                    v-show="isPile&&!isSee&&buyPackageBtn"
                    style="min-width:23%;margin-right:2%"
                    class="btn btn-sm"
                    :class="{'btn-light':message &&(isPile&&message.USER_WHITE_TYPE == '0'),'btn-primary':message &&(isPile &&message.USER_WHITE_TYPE == '1')}"
                    @click="payPackage()"
                  >购买时长包</button>
                  <button
                    :style="isCarport?'width:48%;':'min-width:23%;'"
                    class="btn btn-sm btn-primary"
                    @click="whiteSubmit('change')"
                    v-if="!isSee &&((pileJoinBtn&&isPile)||(carportJoinBtn&&isCarport)||(!(message &&((isPile &&message.USER_WHITE_TYPE == '0')||(isCarport&&message.CARPORT_WHITE_TYPE == '0')))&&editBtn))"
                  >{{message &&((isPile &&message.USER_WHITE_TYPE == '0')||(isCarport&&message.CARPORT_WHITE_TYPE == '0'))?"加入白名单":"保存"}}</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- </div> -->
    <!-- 点击加入白名单(充电) -->
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">加入白名单</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- <div class="form-group">
                <label class="col-sm-12 control-label">用户ID</label>
                <div class="col-sm-12">
                  <input
                    disabled
                    class="form-control"
                    placeholder
                    v-model="  form.userId"
                    maxlength="30"
                  />
                </div>
              </div>-->
              <!-- <div class="form-group" v-if="created">
                <label for="cell-sel" class="col-sm-5 control-label">
                  所在区域
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control col-sm-4 form-group-b"
                    style="float:left"
                    @change="provinceSel()"
                    v-model="pro"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control col-sm-4 form-group-b"
                    style="float:left"
                    @change="citySel()"
                    v-model="city"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control col-sm-4 form-group-b"
                    @change="disSel()"
                    v-model="dis"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>-->
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <!-- <select
                    v-if="created"
                    class="form-control col-sm-12"
                    v-model="  form.groupId"
                    @change="changeGroupId()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>-->
                  <el-select
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    maxlength="30"
                    v-model="form.groupId"
                    @change="changeGroupId()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :label="item.CELL_NAME"
                      :value="item.CELL_ID"
                    ></el-option>
                  </el-select>
                  <input
                    v-if="!created"
                    disabled
                    class="form-control"
                    placeholder
                    v-model="cellName"
                    maxlength="30"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">时长包名</label>
                <div class="col-sm-12">
                  <select v-if="created" class="form-control col-sm-12" v-model="form.packageId">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in packageList"
                      :key="index"
                      :value="item.PACKAGE_ID"
                    >{{item.DESCRIPTION}}</option>
                  </select>
                  <input
                    v-if="!created"
                    disabled
                    class="form-control"
                    placeholder
                    v-model="cellName"
                    maxlength="30"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  每日限制时长
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control col-sm-12" v-model="form.limitDuration">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option v-for="(item,index) in 24" :key="index" :value="item">{{item+'小时'}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  每日重置时间
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="  form.resetHour">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in 24"
                      :key="index"
                      :value="index>9?index+':00':('0'+index + ':00')"
                    >{{index>9?index+':00':('0'+index + ':00')}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">
                  白名单生效日期
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white"
                    name="example-flatpickr-default"
                    v-model="  form.startEffectiveTime"
                    placeholder="请选择"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">白名单失效日期</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white"
                    name="example-flatpickr-default"
                    v-model="  form.expiredTime"
                    placeholder="默认无限制"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="cell-auth-type" class="col-sm-12 control-label">备注</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.remark" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit('add')">保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 点击加入白名单(车棚) -->
    <div
      class="modal fade"
      id="modal-default-fadein-whiteList"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein-whiteList"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">加入白名单</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">用户ID</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.userId"
                    disabled
                  />
                </div>
              </div>-->
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    v-model="form.carportId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="selectChange()"
                  >
                    <el-option
                      v-for="item in carportList"
                      :key="item.CARPORT_ID"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  白名单生效日期
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white-ab"
                    style="background-color: #fff"
                    placeholder="请选择"
                    v-model="form.startTime"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">白名单失效日期</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white-ab"
                    style="background-color: #fff"
                    v-model="form.endTime"
                    placeholder="默认无限制"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="cell-auth-type" class="col-sm-12 control-label">备注</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.remark" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit('add')">保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 购买包 -->
    <div
      class="modal fade"
      id="modal-default-normal-payPackage"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-payPackage"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">购买时长包</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- <div class="form-group">
                <label class="col-sm-12 control-label">所在区域</label>
                <div class="col-sm-12">
                  <select
                    class="form-control width-33"
                    @change="provinceSel()"
                    v-model="pro"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control width-33"
                    @change="citySel()"
                    v-model="city"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control width-33"
                    @change="disSel()"
                    v-model="dis"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>-->

              <div class="form-group">
                <label class="col-sm-12 control-label">小区名称</label>
                <div class="col-sm-12">
                  <!-- <select
                    class="form-control inline-block col-sm-12"
                    v-model="form.groupId"
                    @change="changeGroupId()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>-->
                  <el-select
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    maxlength="30"
                    disabled
                    v-model=" form.groupId"
                    @change="changeCell()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :label="item.CELL_NAME"
                      :value="item.CELL_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">时长包类型</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" disabled value="白名单" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">时长包名</label>
                <div class="col-sm-12">
                  <select class="form-control inline-block col-sm-12" v-model="form.packageId">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in packageList"
                      :key="index"
                      :value="item.PACKAGE_ID"
                    >{{item.DESCRIPTION}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="whiteSubmit('add')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../../Util.js";
export default {
  data() {
    return {
      message: null,
      userType: [
        {
          value: 0,
          label: "普通"
        },
        {
          value: 1,
          label: "白名单"
        }
      ],
      form: {
        userId: "",
        mobilePhone: "",
        userCard: "",
        balanceMoney: "",
        groupId: "",
        startEffectiveTime: "",
        expiredTime: "",
        resetHour: "",
        limitDuration: "",
        allowOther: "",
        type: "",
        packageId: "",
        remark: ""
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      carportList: [],
      packageList: [],
      pro: "",
      city: "",
      dis: "",
      created: true,
      cellName: "",
      loading: false,
      isPile: false,
      isCarport: false,
      isSee: false,
      hasGroupId: true,
      buyPackageBtn: Util.isHavePerm("timeLen/buyChargeUserPackage"),
      pileJoinBtn: Util.isHavePerm("cell/addUser"),
      editBtn: Util.isHavePerm("user/updateUserInfo"),
      pileDelBtn: Util.isHavePerm("cell/deleteUser"),
      carportJoinBtn: Util.isHavePerm("white/addWhiteModel"),
      carportDelBtn: Util.isHavePerm("white/deleteWhiteModel")
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "form.mobilePhone"(val, oldVal) {
      if (!Util.isHavePerm("user/updateUserInfo")) return;
      this.form.mobilePhone = Util.isNumber(val);
    },
    "form.userCard"(val, oldVal) {
      this.form.userCard = Util.isNumber(val);
    },
    "form.balanceMoney"(val, oldVal) {
      this.form.balanceMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    if (
      // this.params.type == "pile" &&
      this.$route.name == "pileWhiteUser"
    ) {
      this.isPile = true;
      this.isCarport = false;
    }
    if (
      // this.params.type == "carport" &&
      this.$route.name == "carportWhiteUser"
    ) {
      this.isCarport = true;
      this.isPile = false;
    }
    if (this.params.type == "see") {
      this.isSee = true;
    }
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    if (this.isPile) {
      this.getChargeWhite(this.$route.params.id);
    } else {
      this.getCarportWhite(this.carportWhiteId);
    }
    this.getUser(this.$route.params.id);
    this.getProvince();
    this.searchCarport();
    this.getAllCell();
  },
  methods: {
    refreshList() {
      if (this.isPile) {
        this.$parent.$refs.walletBalance.getList();
        this.$parent.$refs.chargingOrder.getList();
        this.$parent.$refs.pilePackageOrder.getList();
        this.$parent.$refs.packageList.getList();
      }
      if (this.isCarport) {
        this.$parent.$refs.walletBalance.getList();
        this.$parent.$refs.chargingOrder.getList();
        this.$parent.$refs.packageOrder.getList();
        this.$parent.$refs.stopOrder.getList();
        this.$parent.$refs.inOutRecord.getList();
        this.$parent.$refs.carportPackageList.getList();
      }
    },
    selectChange() {
      // 强制刷新
      this.$forceUpdate();
    },
    changeCell() {
      this.$forceUpdate();
      this.changeGroupId(this.form.cellId);
    },
    changeGroupId() {
      // if (this.hasGroupId) return;
      this.$http
        .get(
          `${Util.searchURL}/FlatComplex/GetWhitePackage/${this.form.groupId}`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.packageList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
      this.cellList.find(item => {
        if (item.CELL_ID == this.form.groupId) {
          this.form.groupId = item.CELL_ID;
          this.cellName = item.CELL_NAME;
        }
      });
    },
    getAllCell(query) {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/SearchBy?key=`)
        .then(res => {
          this.cellList = res.data.data;
          this.loading = false;
        });
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    showAdd() {
      if (this.isPile) {
        if (this.message.USER_WHITE_TYPE == "1") return;
        jQuery("#modal-default-normal").modal("show");

        if (this.created) {
          this.form.groupId = "";
        }
        if (this.message.USER_WHITE_TYPE == "0") {
          this.pro = "";
          this.city = "";
          this.dis = "";
          this.form.limitDuration = "";
          this.form.resetHour = "";
          this.form.startEffectiveTime = "";
          this.form.expiredTime = "";
          this.form.packageId = "";
          this.form.remark = "";
        }
      } else if (this.isCarport) {
        if (this.message.CARPORT_WHITE_TYPE == "1") return;
        jQuery("#modal-default-fadein-whiteList").modal("show");
        this.form.carportId = "";
        this.form.startTime = "";
        this.form.endTime = "";
        this.$forceUpdate();
      }
    },
    delWhiteUser() {
      let url, d;
      if (this.isPile) {
        if (this.message.USER_WHITE_TYPE == "0") return;
        url = `${Util.operateURL}/cell/deleteUser`;
        d = {
          userId: this.form.userId,
          groupId: this.form.groupId
        };
      }
      if (this.isCarport) {
        if (this.message.CARPORT_WHITE_TYPE == "0") return;
        url = `${Util.operateURL}/white/deleteWhiteModel`;
        d = { id: this.carportWhiteId };
      }
      swal("确定移出白名单用户？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http.post(url, d).then(res => {
              if (res.data.code === 200) {
                Util.message("succ", res.data.desc);
                if (this.isCarport) {
                  this.form.carportId = "";
                  this.form.startEffectiveTime = "";
                  this.form.expiredTime = "";
                  this.form.remark = "";
                }
                this.getUser(this.$route.params.id);
                this.refreshList();
              } else {
                Util.message("err", res.data.desc);
              }
            });
            break;
        }
      });
    },
    submit(val) {
      let url = "";
      if (val) {
        if (this.isPile) {
          url = `${Util.operateURL}/cell/addUser`;
        } else if (this.isCarport) {
          url = `${Util.operateURL}/white/addWhiteModel`;
        }
      } else {
        url = `${Util.operateURL}/user/updateUserInfo`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            jQuery("#modal-default-normal").modal("hide");
            jQuery("#modal-default-fadein-whiteList").modal("hide");
            Util.message("succ", res.data.desc);
            this.getUser(this.$route.params.id);
            this.refreshList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    whiteSubmit(val) {
      let url = "";
      if (val) {
        if (
          this.isPile &&
          this.message &&
          this.message.USER_WHITE_TYPE == "1"
        ) {
          url = `${Util.operateURL}/timeLen/buyChargeUserPackage`;
          if (val == "change") {
            this.form.packageId = "";
          }
          if (val == "add") {
            if (!this.form.cellId) {
              Util.message("err", "请选择小区名称");
              return;
            }
            if (!this.form.packageId) {
              Util.message("err", "请选择时长包名");
              return;
            }
          }
        } else if (
          this.isPile &&
          this.message &&
          this.message.USER_WHITE_TYPE == "0"
        ) {
          url = `${Util.operateURL}/cell/addUser`;
        } else if (
          this.isCarport &&
          this.message &&
          this.message.CARPORT_WHITE_TYPE == "1"
        ) {
          this.form.startTime = this.form.startEffectiveTime;
          this.form.endTime = this.form.expiredTime;
          url = `${Util.operateURL}/white/updateWhiteModel`;
        } else if (
          this.isCarport &&
          this.message &&
          this.message.CARPORT_WHITE_TYPE == "0"
        ) {
          this.form.startTime = this.form.startEffectiveTime;
          this.form.endTime = this.form.expiredTime;
          url = `${Util.operateURL}/white/addWhiteModel`;
        }
      } else {
        url = `${Util.operateURL}/user/updateUserInfo`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            jQuery("#modal-default-normal-payPackage").modal("hide");
            Util.message("succ", res.data.desc);
            this.getUser(this.$route.params.id);
            if (this.isPile) {
              this.getChargeWhite(this.$route.params.id);
              this.$parent.$refs.packageList.getList();
            } else {
              this.getCarportWhite(this.carportWhiteId);
            }
            this.refreshList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getUser(val) {
      this.hasGroupId = true;
      this.$http.get(`${Util.searchURL}/User/Info/${val}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data;
            this.message = d;
            this.whiteMessage = d;
            this.carportWhiteId = d.CARPORT_WHITE_ID;
            this.form.userId = d.USER_ID;
            this.form.mobilePhone = Util.isHavePerm("user/updateUserInfo")
              ? d.MOBILE_PHONE
              : d.MOBILE_PHONE
              ? Util.regMobile(d.MOBILE_PHONE)
              : d.MOBILE_PHONE;
            this.form.userCard = d.CARD_NO;
            this.form.cardId = d.CARD_NO;
            this.form.balanceMoney = "";
            this.form.groupId = d.GROUP_ID ? d.GROUP_ID : "";
            if (!d.GROUP_ID) {
              this.hasGroupId = false;
            }
            if (this.isCarport) {
              this.getCarportWhite(this.carportWhiteId);
            } else {
              this.getChargeWhite(this.$route.params.id);
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    payPackage() {
      if (this.isPile && this.message.USER_WHITE_TYPE == "0") return;
      jQuery("#modal-default-normal-payPackage").modal("show");
      this.changeGroupId(this.form.groupId);
      this.form.cellId = this.form.groupId;
      this.packageList = [];
      this.form.packageId = "";
      // this.getUser(this.$route.params.id);
    },
    getCarportWhite(val) {
      if (!val) return;
      this.$http.get(`${Util.searchURL}/Carport/GetWhiteList/${val}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data;
            this.whiteMessage = d;
            this.form.startEffectiveTime = d.START_TIME;
            this.form.expiredTime = d.END_TIME;
            this.form.carportId = d.CARPORT_ID;
            this.form.id = d.ID;
            this.form.remark = d.REMARK;
            this.$forceUpdate();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getChargeWhite(val) {
      this.$http.get(`${Util.searchURL}/FlatComplex/GetWhite/${val}`).then(
        res => {
          if (res.data.code === 200) {
            // this.packageList = res.data.data.package;
            let d = res.data.data.data;
            this.whiteMessage = d;
            if (d) {
              this.form.userPackageId = d.PACKAGE_ORDER_ID
                ? d.PACKAGE_ORDER_ID
                : "";
              this.form.limitDuration = d.LIMIT_DURATION;
              this.form.resetHour = d.RESET_HOUR;
              this.form.startEffectiveTime = d.START_EFFECTIVE_TIME;
              this.form.expiredTime = d.EXPIRED_TIME;
              this.form.packageId = "";
              this.form.remark = d.REMARK;
            } else {
              this.form.userPackageId = "";
              this.form.limitDuration = "";
              this.form.resetHour = "";
              this.form.startEffectiveTime = "";
              this.form.expiredTime = "";
              this.form.packageId = "";
              this.form.remark = "";
              this.pro = "";
              this.city = "";
              this.dis = "";
            }
            // Util.displayAreaCell(this.form.groupId, this, true, true);
            // this.form = Object.assign({}, this.form);
            // this.$forceUpdate();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.dis = "";
            this.form.groupId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
            this.form.groupId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.groupId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  }
};
</script>

<style scoped>
</style>